import React from 'react';

import { Flex } from '@chakra-ui/react';

import { ArrowBack } from 'assets/assetsV1/iconComponents';
import { ArrowForward } from 'assets/assetsV1/iconComponents/ArrowForward';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export interface CarouselControlProps {
  noOfTabs: number;
  onChange?: (index: number) => void;
  selectedIndex?: number;
  isDisabled?: boolean;
}

const CarouselControl = ({ noOfTabs, onChange, selectedIndex, isDisabled = false }: CarouselControlProps) => {
  const goToNext = () => {
    onChange(selectedIndex + 1);
  };

  const goToPrev = () => {
    onChange(selectedIndex - 1);
  };

  return (
    <Flex alignItems="center">
      <Button
        variant="tertiary"
        StartIcon={ArrowBack}
        onClick={goToPrev}
        isDisabled={isDisabled || selectedIndex === 0}
      />
      <TextBodyMedium bold color="text.g2">
        {selectedIndex + 1}
      </TextBodyMedium>
      <TextBodyMedium bold color="text.g2" mx={1}>
        /
      </TextBodyMedium>
      <TextBodyMedium bold color="text.g2">
        {noOfTabs}
      </TextBodyMedium>
      <Button
        variant="tertiary"
        StartIcon={ArrowForward}
        onClick={goToNext}
        isDisabled={isDisabled || selectedIndex === noOfTabs - 1}
      />
    </Flex>
  );
};

export default CarouselControl;
